import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wrong-link',
  templateUrl: './wrong-link.component.html',
  styleUrls: ['./wrong-link.component.scss']
})
export class WrongLinkComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
